<div *ngIf="(params.data && !params.data.editable)">
    <input type="checkbox" [(ngModel)]="params.data[params.colDef.field]" class="disabled" >
</div>

<div *ngIf="(params.data && params.data.editable) && isReports">
    <input type="checkbox" [(ngModel)]="params.data[params.colDef.field]" class="disabled" >
</div>

<div *ngIf="params.data && params.data.editable && !isReports">
    <input type="checkbox" [(ngModel)]="displayCheckboxValue" (ngModelChange)="onCheckboxValueInput($event)"><br/>
    <span class="requiredLabel" *ngIf="currentField === 'monthlyconfirmation' && !displayCheckboxValue"></span>
    <span class="requiredLabel optional" *ngIf="showCheckboxValidationError"></span>
</div>